// check if bigscreen mode is active
// url has query string ?hideItems=12,23,34
// if yes, dont add icons to map and dont
// show in quickbar information
// https://tree.taiga.io/project/eventhubhq-eventhubclient/issue/641

export default function CheckBigcreenIcon({ id, arrayPlaces, typePlace }) {
  if (HQ.Properties.mode !== "bigscreen") return;

  // check query string in url
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const hideItems = urlParams.get("hideItems");

  if (!hideItems) return;

  // split string to array
  const hideItemsArray = hideItems.split(",").map(Number);

  if (typePlace === "information") {
    // fing id in hideItemsArray and return true or false
    const isHidden = hideItemsArray.includes(id);

    return isHidden;
  } else {
    if (!hideItemsArray.includes(id)) return;

    let chekIfExist = false;
    arrayPlaces.map((place) => {
      if (place.id === id) {
        place?.children?.map((_) => {
          chekIfExist = true;
        });
      }
    });

    return chekIfExist;
  }
}
